import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http'
import { inject } from '@angular/core'
import { tap } from 'rxjs'
import { AuthService } from '../services/auth.service'
import { ToastService } from '../services/toast.service'
import { Router } from '@angular/router'

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService)
  const toastService = inject(ToastService)
  const router = inject(Router)
  const UNAUTHORIZED_STATUS_CODE = 401

  const authToken = auth.accessToken
  const IMPauthToken = auth.IMPAccessToken

  // Helper function to delete all cookies
  const deleteAllCookies = () => {
    const cookies = document.cookie.split(';')
    for (let cookie of cookies) {
      const cookieName = cookie.split('=')[0].trim()
      document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
    }
  }

  // TODO: for impersonate, or otherwise, might want to remove this
  if (
    !authToken ||
    req.url.includes('/login') ||
    req.url.includes('/social-media/meta-metrics')
  ) {
    return next(req)
  }

  // Skip auth headers for social media API since it doesn't require authentication
  if (req.url.includes('jovb4kvl6e.execute-api.us-east-1.amazonaws.com')) {
    return next(req)
  }

  if (!auth.isAuthValid()) {
    auth.logout()
  }

  const headers = { Authorization: `Bearer ${authToken}` } as any

  if (IMPauthToken) {
    headers['H2H-Authorization'] = IMPauthToken
  }

  // Check for the X-Impersonate-User header that we set for spam reports
  // Only super admins should be able to use this
  if (req.headers.has('X-Impersonate-User') && auth.isSuperAdmin) {
    headers['X-Impersonate-User'] = req.headers.get('X-Impersonate-User')
  }

  const authReq = req.clone({ setHeaders: headers })
  return next(authReq).pipe(
    tap({
      error: (err: HttpErrorResponse) => {
        // reload page on unauthorized status code
        if (err.status === UNAUTHORIZED_STATUS_CODE) {
          // Check if this is an "Invalid user token" error - let error interceptor handle it
          // This only happens when we sent an auth token that was invalid/expired
          if (err.error?.message === 'Invalid user token') {
            console.log(
              'Invalid user token detected in auth interceptor, letting error interceptor handle it',
            )
            return // Let the error interceptor handle this case
          }

          // For other 401 errors, show toast and reload page
          toastService.presentToast({
            message: 'There was an error. Refreshing the page.',
            color: 'danger',
          })
          deleteAllCookies() // Maybe TODO, might not want to do this if we make more use of cookies
          setTimeout(() => location.reload(), 1000)
        }
      },
    }),
  )
}
